import { init, Integrations } from '@sentry/react'
import { IS_PROD } from '../configuration'

export const setupSentry = (): void => {
  init({
    // See https://sentry.io/settings/realworld-one/projects/desktop-app/
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENVIRONMENT,
    integrations: [
      new Integrations.Breadcrumbs({
        console: false,
      }),
    ],
    tracesSampler: () => (IS_PROD ? 1 : 0.2),
  })
}
